var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortlinks01 = function SvgShortlinks01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shortlinks-01_svg2__a",
    x1: -61.84,
    x2: 108.26,
    y1: 123.38,
    y2: -46.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlinks-01_svg2__a",
    id: "shortlinks-01_svg2__b",
    x1: -56,
    x2: 114.1,
    y1: 129.22,
    y2: -40.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlinks-01_svg2__a",
    id: "shortlinks-01_svg2__c",
    x1: -56,
    x2: 114.1,
    y1: 129.23,
    y2: -40.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlinks-01_svg2__a",
    id: "shortlinks-01_svg2__d",
    x1: -15.48,
    x2: 154.61,
    y1: 169.74,
    y2: -0.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlinks-01_svg2__a",
    id: "shortlinks-01_svg2__e",
    x1: -15.46,
    x2: 154.64,
    y1: 169.76,
    y2: -0.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlinks-01_svg2__a",
    id: "shortlinks-01_svg2__f",
    x1: -15.44,
    x2: 154.66,
    y1: 169.79,
    y2: -0.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlinks-01_svg2__a",
    id: "shortlinks-01_svg2__g",
    x1: 54.72,
    x2: 224.82,
    y1: 239.95,
    y2: 69.85
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.07 42.95c-1.5 0-3-.6-4.1-1.7L20.28 28.56c-2.3-2.3-2.3-5.99 0-8.29s5.99-2.3 8.29 0l12.69 12.69c2.3 2.3 2.3 5.99 0 8.29s-2.6 1.7-4.1 1.7h-.1Z",
    style: {
      fill: "url(#shortlinks-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.39 66.73c-.5 0-1 0-1.5-.2l-17.38-4.6c-3.1-.8-5-4-4.2-7.19.8-3.1 4-5 7.19-4.2l17.38 4.6c3.1.8 5 4 4.2 7.19-.7 2.6-3.1 4.4-5.69 4.4",
    style: {
      fill: "url(#shortlinks-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.95 29.16c-2.6 0-5-1.7-5.69-4.4l-4.6-17.38c-.8-3.1 1-6.29 4.2-7.19 3.1-.8 6.29 1 7.19 4.2l4.6 17.38c.8 3.1-1 6.29-4.2 7.19-.5.1-1 .2-1.5.2",
    style: {
      fill: "url(#shortlinks-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.61 92.1c-1.5 0-3-.6-4.1-1.7-2.3-2.3-2.3-5.99 0-8.29l11.59-11.59c3.8-3.8 5.89-8.79 5.89-14.19s-2.1-10.39-5.89-14.19c-7.79-7.79-20.48-7.79-28.27 0L72.24 53.73c-2.3 2.3-5.99 2.3-8.29 0s-2.3-5.99 0-8.29l11.59-11.59c12.39-12.39 32.47-12.39 44.86 0 5.99 5.99 9.29 13.99 9.29 22.48s-3.3 16.48-9.29 22.38L108.81 90.3c-1.1 1.1-2.6 1.7-4.1 1.7z",
    style: {
      fill: "url(#shortlinks-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.46 129.57c-8.09 0-16.28-3.1-22.48-9.29-5.99-5.99-9.29-13.99-9.29-22.48s3.3-16.48 9.29-22.38l11.59-11.59c2.3-2.3 5.99-2.3 8.29 0s2.3 5.99 0 8.29L42.27 83.71c-3.8 3.8-5.89 8.79-5.89 14.19s2.1 10.39 5.89 14.19c7.79 7.79 20.48 7.79 28.27 0l11.59-11.59c2.3-2.3 5.99-2.3 8.29 0s2.3 5.99 0 8.29l-11.59 11.59c-6.19 6.19-14.29 9.29-22.48 9.29l.1-.1Z",
    style: {
      fill: "url(#shortlinks-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.95 99.2c-1.5 0-3-.6-4.1-1.7-2.3-2.3-2.3-5.99 0-8.29l32.37-32.37c2.3-2.3 5.99-2.3 8.29 0s2.3 5.99 0 8.29L65.14 97.5c-1.1 1.1-2.6 1.7-4.1 1.7h-.1Z",
    style: {
      fill: "url(#shortlinks-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.78 199.9h-.9c-2.3-.3-4.2-2.1-4.8-4.4l-20.88-82.12c-.5-2 0-4.1 1.5-5.59 1.5-1.5 3.6-2 5.59-1.5l82.12 20.88c2.3.6 4 2.5 4.4 4.8.3 2.3-.7 4.7-2.8 5.89l-19.68 11.89 10.89 13.99c5.49 6.99 4.9 16.98-1.4 23.28-6.29 6.29-16.28 6.89-23.28 1.4l-13.99-10.89-11.89 19.68c-1.1 1.8-3 2.8-5 2.8l.1-.1Zm15.29-36.96c1.3 0 2.6.4 3.6 1.2l19.18 14.99c2.4 1.8 5.69 1.6 7.79-.5s2.3-5.49.5-7.79l-14.99-19.18c-1-1.3-1.4-3-1.1-4.7a6.2 6.2 0 0 1 2.7-4l13.29-7.99L120 119.98l14.99 59.04 7.99-13.29c.9-1.4 2.3-2.4 4-2.7h1.1v-.1Z",
    style: {
      fill: "url(#shortlinks-01_svg2__g)"
    }
  }));
};
export default SvgShortlinks01;